import AccordionSegment from './AccordionSegment';

// Breakpoints waarvanaf een segment standaard open kan staan (data-accordion-default-open).
const BREAKPOINTS = {
	md: '(min-width: 768px)',
	lg: '(min-width: 992px)',
};

export default class Accordion {
	constructor(el) {
		this.segments = el.querySelectorAll('[data-accordion-segment]');
		this.accordionSegments = new Map();

		this.segments.forEach(segment => {
			const accordionSegment = new AccordionSegment(segment);
			this.accordionSegments.set(segment, accordionSegment);
		});

		this.initDefaultOpen(el);
	}

	initDefaultOpen(el) {
		const segment = el.querySelector('[data-accordion-default-open]');

		if (!segment) {
			return;
		}

		this.defaultOpenSegment = this.accordionSegments.get(segment);

		if (!this.defaultOpenSegment || !this.defaultOpenSegment.target) {
			return;
		}

		this.breakpoint = window.matchMedia(BREAKPOINTS[segment.dataset.accordionDefaultOpen] || BREAKPOINTS.md);
		this.boundBreakpointListener = this.breakpointListener.bind(this);
		this.breakpoint.addEventListener('change', this.boundBreakpointListener);
		this.breakpointListener(this.breakpoint);
	}

	breakpointListener(event) {
		// Zodra de bezoeker zelf geklikt heeft, laten we de status met rust.
		if (this.defaultOpenSegment.userToggled) {
			return;
		}

		event.matches ? this.defaultOpenSegment.openInstant() : this.defaultOpenSegment.closeInstant();
	}

	destroy() {
		if (this.breakpoint) {
			this.breakpoint.removeEventListener('change', this.boundBreakpointListener);
		}
	}
}
